// /project-root/react-app/src/App.js
// Updated to forward RAW_AUDIO_CHUNK buffers directly to the WebSocket
// and to use transferable objects from the content‑script.

import React, { useState, useEffect, useMemo } from 'react';
import './app.css';
import AuthUtils from './auth/auth_utils';
import AppRouter from './router/router';
import { AuthProvider } from './auth/auth_context';
import { UserProvider } from './auth/user_context';
import UserInitializer from './auth/user_initializer';
import EstablishPage from './auth/establish';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [mode, setMode] = useState('light');
  const isCallbackRoute = window.location.pathname === '/callback';
  const isGuestJoinRoute = window.location.pathname === '/guest-join';

  useEffect(() => {
    // Clear any stored meeting config to prevent auto-navigation to meeting
    if (sessionStorage.getItem('meetingConfig')) {
      sessionStorage.removeItem('meetingConfig');
    }
    
    if (!isCallbackRoute && !isGuestJoinRoute) {
      checkAuthentication();
    } else {
      setIsLoading(false);
    }
  }, [isCallbackRoute, isGuestJoinRoute]);

  const checkAuthentication = () => {
    const sid = AuthUtils.GetAuthToken();
    if (sid) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <UserProvider>
      <AuthProvider>
        <UserInitializer>
                  {isAuthenticated || isCallbackRoute || isGuestJoinRoute ? (
          <AppRouter />
        ) : (
          <EstablishPage />
        )}
        </UserInitializer>
      </AuthProvider>
    </UserProvider>
  );
}

export default App;
